// Existing accounts need at least one nonempty dog image to appear on the map.
export const isOldProfileWithoutDogImages = (profile) => {
  if (profile.is_old_user !== 1 && profile.is_old_user !== true) return false;
  const images = Array.isArray(profile.dog_images)
    ? profile.dog_images
    : [profile.dog_images];
  return !images.some((image) => typeof image === "string" && image.trim() !== "");
};
